import React from "react";
import { FiArrowRight, FiCalendar, FiX } from "react-icons/fi";
import PageModal from "../../Dashboard/Components/PageModal";

function AnnouncementModal({ announcement, onClose, formatDate }) {
  if (!announcement) return null;

  return (
    <PageModal>
      <div className="bg-white p-5 md:p-6 rounded-xl max-w-2xl w-full relative shadow-lg">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 bg-white rounded-full p-1 hover:bg-gray-100 transition-colors z-10"
        >
          <FiX size={20} />
        </button>

        {announcement.imageUrl && (
          <div className="relative -mx-5 -mt-5 mb-5 md:-mx-6 md:-mt-6">
            <img
              src={announcement.imageUrl}
              alt={announcement.title}
              className="w-full h-[200px] object-cover rounded-t-xl"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>

            {announcement.isNew && (
              <div className="absolute top-4 left-4 bg-[#8FCD00] text-white px-3 py-1 rounded-full text-xs font-medium z-10 flex items-center shadow-sm">
                <span className="mr-1 h-1.5 w-1.5 bg-white rounded-full inline-block"></span>
                NEW
              </div>
            )}
          </div>
        )}

        <div className="mb-4">
          {!announcement.imageUrl && announcement.isNew && (
            <div className="inline-flex items-center bg-[#8FCD00]/10 text-[#8FCD00] px-3 py-1 rounded-full text-xs font-medium mb-3">
              <span className="mr-1 h-1.5 w-1.5 bg-[#8FCD00] rounded-full inline-block"></span>
              NEW
            </div>
          )}

          <h3 className="text-lg font-semibold text-[#363062]">
            {announcement.title}
          </h3>

          <div className="flex items-center mt-2 text-xs text-gray-500">
            <FiCalendar className="mr-1.5 h-3 w-3" />
            <span>{formatDate(announcement.createdAt)}</span>
          </div>
        </div>

        {announcement.poster && (
          <div className="mb-4 bg-gray-50 p-2 rounded-lg">
            <img
              src={announcement.poster}
              alt="Poster"
              className="w-full h-[200px] object-contain"
            />
          </div>
        )}

        {announcement.description && (
          <div className="mb-4 text-sm text-gray-600 border-l-2 border-[#363062]/20 pl-3 py-1">
            {announcement.description}
          </div>
        )}

        <div className="text-sm text-gray-700 mb-4 leading-relaxed">
          <div className="whitespace-pre-wrap">{announcement.content}</div>
        </div>

        {announcement.Details && (
          <div className="text-sm text-gray-700 mb-4 whitespace-pre-wrap bg-gray-50 p-3 rounded-lg">
            {announcement.Details}
          </div>
        )}

        {announcement.link && (
          <div className="mt-6 border-t border-gray-100 pt-4">
            <a
              href={announcement.link}
              className="inline-flex items-center text-sm font-medium text-[#363062] hover:text-[#8FCD00] transition-colors group"
            >
              Learn More
              <FiArrowRight className="ml-1.5 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
        )}
      </div>
    </PageModal>
  );
}

export default AnnouncementModal;
